var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgManuallyEnteredReading = function SvgManuallyEnteredReading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.96447 1.00001L1 3.96527L3.96447 6.93053L6.92894 3.96527L3.96447 1.00001Z",
    stroke: "#4D4D4D",
    strokeWidth: 0.998369,
    strokeMiterlimit: 10
  })));
};
export default SvgManuallyEnteredReading;